import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import interest from './modules/interest'
import ageGroup from './modules/ageGroup'
import tag from './modules/tag'
import discovery from './modules/discovery'
import discoveryPage from './modules/discoveryPage'
import quote from './modules/quote'
import notification from './modules/notification'
import reportCategory from './modules/reportCategory'
import report from './modules/report'
import versionControl from './modules/version-control'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    interest,
    ageGroup,
    tag,
    discovery,
    discoveryPage,
    quote,
    reportCategory,
    notification,
    report,
    versionControl,
  },
  state: {
    controls: {
      showDrawer: true,
    },
  },
  mutations: {
    toggleDrawer(state, value) {
      state.controls.showDrawer = value
    },
  },
})
